module.exports = "/wp-content/plugins/farmacy/assets/js/images/the_original_farm_logo_white-baceab761be19cafa58c8371df4f16db.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/farm-branding/img/the_original_farm_logo_white.svg
 ** module id = 208
 ** module chunks = 1 23 27 28 38 42 62 75 80 88 134
 **/